export default __webpack_public_path__ + "static/media/lion.4ef876ac.png";